function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.766 3c-1.76 6.158-2.553 10.095-5.845 13.681 1.394.274 2.799.472 4.192.543-1.684 3.212-3.644 5.068-6.852 7.274 1.83.444 3.653.695 5.482.87-2.088 3.055-4.524 5.058-7.457 7.31 2.152.505 4.297.836 6.45 1.05-2.808 3.347-6.09 5.537-10.038 7.998a80.042 80.042 0 009.674 1.23c-3.508 3.916-7.638 6.342-12.657 9.12 11.361 1.924 22.74 2.14 34.101 0-4.584-2.732-9.053-5.148-12.697-9.083 3.235-.19 6.48-.581 9.714-1.267-3.604-2.42-7.112-4.568-10.037-7.926a39.82 39.82 0 006.45-1.122c-2.67-2.208-5.245-4.187-7.417-7.239 1.811-.16 3.63-.452 5.442-.94-2.87-2.187-5.109-4.032-6.893-7.311a34.67 34.67 0 004.232-.507C30.36 13.15 29.668 9.166 27.766 3z",
  fill: "none",
  stroke: "var(--primary-color, #000)"
});

var SvgChristmastree = function SvgChristmastree(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChristmastree, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Christmas tree.06cb951a.svg";
export { ForwardRef as ReactComponent };